import type { PurchaseOrderStatusType, InventoryTransferStatusType } from '@/api/admin-inventory-types'
import type { StatusColor } from '@/components/base/status-cell'
import { fromPrecision } from '@/utils/currency'

export const purchaseOrderStatusColor = (status: PurchaseOrderStatusType): StatusColor => {
	switch (status) {
		case 'RECEIVED':
			return 'green'
		case 'PARTIALLY_RECEIVED':
			return 'orange'
		case 'CANCELLED':
			return 'red'
		case 'ORDERED':
			return 'blue'
		default:
			return 'grey'
	}
}

export const transferStatusColor = (status: InventoryTransferStatusType): StatusColor => {
	switch (status) {
		case 'RECEIVED':
			return 'green'
		case 'IN_TRANSIT':
			return 'blue'
		case 'CANCELLED':
			return 'red'
		default:
			return 'grey'
	}
}

export const formatUnitCost = (line: { unitCost?: { value: number; precision: number } }, currencyCode?: string) => {
	if (!line.unitCost) return '—'
	const value = fromPrecision(line.unitCost)
	return currencyCode ? `${value} ${currencyCode}` : String(value)
}
